import fs from 'node:fs'
import path from 'node:path'
import type { LinterInfo } from '@cli-types/next-adapter/config.js'
import {
  BIOME_CONFIG_FILES,
  ESLINT_CONFIG_FILES,
  OXLINT_CONFIG_FILES
} from '@cli-constants/lint-configs.js'

export function detectLinter(cwd: string): LinterInfo {
  for (const f of OXLINT_CONFIG_FILES) {
    if (fs.existsSync(path.join(cwd, f))) {
      return { type: 'oxlint', configFile: f }
    }
  }

  for (const f of BIOME_CONFIG_FILES) {
    if (fs.existsSync(path.join(cwd, f))) {
      return { type: 'biome', configFile: f }
    }
  }

  for (const f of ESLINT_CONFIG_FILES) {
    if (fs.existsSync(path.join(cwd, f))) {
      return { type: 'eslint', configFile: f }
    }
  }

  const pkgPath = path.join(cwd, 'package.json')
  if (fs.existsSync(pkgPath)) {
    try {
      const pkg = JSON.parse(fs.readFileSync(pkgPath, 'utf-8'))
      if (pkg.eslintConfig) {
        return { type: 'eslint', configFile: 'package.json (eslintConfig)' }
      }
    } catch {}
  }

  return { type: 'none', configFile: null }
}
